import type {Dayjs} from 'dayjs'
import type {UserSettings} from '@package/shared'

export const formatLocalDate = (date: Dayjs, userSettings: UserSettings, includeWeekday = false): string => {
  return date.toDate().toLocaleDateString(undefined, {
    day: '2-digit',
    month: 'short',
    weekday: includeWeekday ? 'long' : undefined,
    timeZone: userSettings.timezone,
  })
}
